import React, { forwardRef } from "react";
import { TimePicker } from "@progress/kendo-react-dateinputs";

/**
 * DKNTimePicker — Daikin design system time picker.
 * Wraps Kendo TimePicker.
 *
 * Props:
 *   value     Date | null
 *   onChange  (e) => void  — e.value is a Date
 *   label     string
 *   error     string
 *   format    string (default: "HH:mm")
 *   steps     { hour, minute } — picker steps
 *   fullWidth boolean (default: false)
 *   disabled  boolean
 */
const DKNTimePicker = forwardRef(function DKNTimePicker(
  {
    value,
    onChange,
    label,
    error,
    format = "HH:mm",
    steps,
    fullWidth = false,
    disabled = false,
    className = "",
    style,
    ...rest
  },
  ref
) {
  return (
    <div
      className={`dkn-input-wrap${fullWidth ? " dkn-input-full" : ""}${error ? " dkn-input-error" : ""} ${className}`}
      style={style}
    >
      {label && <label className="dkn-input-label">{label}</label>}
      <TimePicker
        ref={ref}
        value={value}
        onChange={onChange}
        format={format}
        steps={steps}
        disabled={disabled}
        className={`dkn-input${error ? " dkn-input-invalid" : ""}`}
        {...rest}
      />
      {error && <span className="dkn-input-helper-text">{error}</span>}
    </div>
  );
});

export default DKNTimePicker;
